import { enumImageIndex } from "../constants";
import { QBoxOverlay_AppIcon } from "./QBoxOverlay_AppIcon";

export class QBoxOverlay_Lock extends QBoxOverlay_AppIcon {
  constructor() {
    super();
    this.overlayType = "lock";
  }
}
